import React from 'react';
import { string, bool, object } from 'prop-types';
import classnames from 'classnames';

import Icon from 'foundations/Icons/Icon';

import styles from './Error.css';

const Error = props => {
  const {
    description = '',
    darkBg,
    icon = { icon: 'warning', type: '20' }
  } = props;
  const customClasses = classnames({ [styles.darkBg]: darkBg });

  return (
    <div className={`${styles.errorWrapper} ${customClasses}`}>

      <Icon {...icon} />

      <p className={`small ${styles.errorText}`}>{description}</p>
    </div>
  );
};

Error.propTypes = {
  error: bool,
  icon: object,
  darkBg: bool,
  description: string
};

export default Error;


// WEBPACK FOOTER //
// ./src/uis/common/Error/Error.js